import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dynamic-dropdown-view',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    CommonModule,
  ],
  templateUrl: './dynamic-dropdown-view.component.html',
  styleUrl: './dynamic-dropdown-view.component.scss',
})
export class DynamicDropdownViewComponent<T> implements OnInit{
  @Input() labelName = 'Select';
  @Input() items: T[];
  @Input() overrideId?: any;
  @Input() overrideIdField?: keyof T;
  @Input() overrideItem?: T;
  @Input() displayWithFn!: (item: T) => string;
  @Input() itemTemplateFn!: (item: T) => string;
  @Input() showSelectedItemChange = false;
  @Input() noItemsMessage = 'No items available.';

  @Output() itemSelected = new EventEmitter<T>();
  @Output() loadingFailed = new EventEmitter<any>();
  @Output() itemSelectedFromOverride = new EventEmitter<any>();

  itemFormControl = new UntypedFormControl('');
  filteredItems$!: Observable<T[]>;

  displayFn = (item: T): string => {
    return item ? this.displayWithFn(item): '';
  };

  constructor() { }

  ngOnInit(): void {
    this.filteredItems$ = this.itemFormControl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value.toLowerCase() : this.displayWithFn(value).toLowerCase()),
      map(name => this.filterOptions(name)),
    );

    if (this.overrideId && this.overrideIdField)
    {
      const match = this.items.find(x => x[this.overrideIdField!] === this.overrideId);
      if (match)
      {
        this.itemFormControl.setValue(match);
      }
    }
    else if (this.overrideItem){
      this.itemFormControl.setValue(this.overrideItem);
      this.selectItemForOverride(this.overrideItem);
    }
  }

  selectItem(item: T): void {
    this.itemSelected.emit(item);
  }

  filterOptions(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.items.filter(option => this.displayWithFn(option).toLowerCase().includes(filterValue));
  }

  selectItemForOverride(item: T): void {
    this.itemSelectedFromOverride.emit(item);
  }
}
